import React, { useCallback, useEffect, useState } from 'react';
import { api, brl, dateStr } from '../lib/api';
import { toast } from 'sonner';
import { X, AlertTriangle } from 'lucide-react';

export default function Avaria() {
  const [products, setProducts] = useState([]);
  const [losses, setLosses] = useState([]);
  const [modal, setModal] = useState(null);
  const [qty, setQty] = useState('');
  const [reason, setReason] = useState('');

  const load = useCallback(async () => {
    const [p, l] = await Promise.all([api.get('/products'), api.get('/losses')]);
    setProducts(p.data); setLosses(l.data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const submit = async () => {
    const n = Number(qty);
    if (!n || n <= 0) { toast.error('Quantidade inválida'); return; }
    if (!reason.trim()) { toast.error('Motivo obrigatório'); return; }
    try {
      await api.post('/losses', { product_id: modal.id, quantity: n, reason });
      toast.success('Avaria registrada');
      setModal(null); setQty(''); setReason(''); load();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Erro'); }
  };

  return (
    <div className="p-4 h-full overflow-y-auto space-y-4">
      <h2 className="text-xl font-black flex items-center gap-2"><AlertTriangle className="text-amber-500"/> Avaria / Perda</h2>
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 text-sm text-amber-800">Avarias reduzem estoque mas NÃO contam como vendas ou receita.</div>

      <div>
        <h3 className="font-bold mb-2">Registrar perda</h3>
        <div className="space-y-2">
          {products.filter(p => p.stock > 0).map((p) => (
            <button key={p.id} onClick={() => setModal(p)} data-testid={`loss-product-${p.id}`}
                    className="w-full bg-white rounded-xl border border-slate-200 p-3 flex justify-between items-center active:scale-[0.98]">
              <div className="text-left">
                <div className="font-bold">{p.name}</div>
                <div className="text-xs text-slate-500">Custo {brl(p.cost)} · Estoque {p.stock}</div>
              </div>
              <span className="text-amber-600 font-bold text-sm">Registrar</span>
            </button>
          ))}
        </div>
      </div>

      <div>
        <h3 className="font-bold mb-2 mt-4">Histórico</h3>
        <div className="space-y-1">
          {losses.map((l) => (
            <div key={l.id} className="bg-white rounded-lg border border-slate-100 p-2 text-sm flex justify-between">
              <div>
                <div className="font-semibold">{l.product_name} · {l.quantity} un</div>
                <div className="text-xs text-slate-500">{dateStr(l.timestamp)} · {l.username} · {l.reason}</div>
              </div>
              <div className="font-black text-red-600">−{brl(l.total_cost)}</div>
            </div>
          ))}
          {losses.length === 0 && <div className="text-slate-500 text-sm">Nenhuma avaria</div>}
        </div>
      </div>

      {modal && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center sm:justify-center" onClick={() => setModal(null)}>
          <div onClick={(e) => e.stopPropagation()} className="bg-white w-full sm:max-w-md rounded-t-3xl sm:rounded-3xl p-4 space-y-3">
            <div className="flex items-center justify-between">
              <div className="font-black">Perda · {modal.name}</div>
              <button onClick={() => setModal(null)}><X/></button>
            </div>
            <input type="number" placeholder="Quantidade" value={qty} onChange={(e) => setQty(e.target.value)} data-testid="loss-qty"
                   className="w-full h-12 rounded-xl border border-slate-200 px-3 text-lg font-bold"/>
            <input placeholder="Motivo (obrigatório)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="loss-reason"
                   className="w-full h-11 rounded-xl border border-slate-200 px-3"/>
            <button onClick={submit} data-testid="loss-submit" className="w-full h-12 rounded-xl bg-red-500 text-white font-black active:scale-[0.98]">Registrar perda</button>
          </div>
        </div>
      )}
    </div>
  );
}
